export default "__VITE_ASSET__BNIo9$0w__"